import Aos from 'aos';

export function aosConfig() {
  Aos.init({
    duration: 1000,
    once: true,
  });
}
